module.exports = __webpack_public_path__ + "static/media/DPW.37929e20.png";